import axios from 'axios'
import { configUrl } from '@/lib/configUrl'

const lang = localStorage.getItem('lang') || 'zh'
const service = axios.create({
  baseURL: configUrl,
  timeout: 20 * 60 * 1000
})
service.interceptors.request.use(
  config => {
    config.withCredentials = true
    config.headers['Accept-Language'] = 'en'
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Accept-Language'] = lang
    config.headers['accessToken'] = window.sessionStorage.getItem(
      'accessToken'
    )
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const { data, status, statusText: message } = response
    if (status === 200) {
      return data
    } else {
      return {
        error: true,
        message
      }
    }
  },
  error => {
    return error
  }
)

export default service
